function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("rect", {
  x: 10,
  y: 38,
  width: 40,
  height: 2,
  fill: "#adafb5"
}), React.createElement("polygon", {
  points: "33 25 18 24.98 18 20 33 20.02 33 25",
  fill: "#adafb5"
}), React.createElement("rect", {
  x: 18,
  y: 32,
  width: 15,
  height: 5,
  fill: "#adafb5"
}), React.createElement("rect", {
  x: 28,
  y: 26,
  width: 15,
  height: 5,
  fill: "#adafb5"
}), React.createElement("polygon", {
  points: "27 31 18 30.98 18 26 27 26.02 27 31",
  fill: "#adafb5"
}), React.createElement("rect", {
  x: 34,
  y: 20,
  width: 9,
  height: 5,
  fill: "#adafb5"
}), React.createElement("rect", {
  x: 34,
  y: 32,
  width: 9,
  height: 5,
  fill: "#adafb5"
})));

function SvgWall(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/wall.a245b303.svg";
export { SvgWall as ReactComponent };